export default {
  labels: {
    invoice: 'Invoice',
  },
};
